import { PreviewEditTemplateActions } from "../../../../../ngapp/src/app/preview-edit-template/state/preview-edit-template.actions";
angular.module('autoremind.services')
    .factory('jobService', ['$rootScope', '$http', '$q', '$sce', '$log', 'dialogs', '$enhancedHttp', '$uibModal', '$filter', 'storeDowngraded', '$interval', 'eventSharingService',
    function ($rootScope, $http, $q, $sce, $log, dialogs, $enhancedHttp, $uibModal, $filter, storeDowngraded, $interval, eventSharingService) {
        const APPOINTMENT = 'appointment';
        const ORDERS = 'orders';
        var service = null;
        service = {
            jobPreviousName: '',
            selectedCategory: null,
            categories: [],
            jobFormDirty: false,
            selectedProvider: null,
            selectedReason: null,
            selectedLocation: null,
            selectedAppointmentState: null,
            selectedCategoryId: null,
            soundSequences: [],
            templateUpdateModel: {},
            isModelProcessed: false,
            species: [],
            breed: [],
            selectedSpecies: null,
            selectedBreed: null,
            speciesAndBreed: [],
            isVets: false,
            retryInterval: undefined,
            maxTries: 3,
            appointmentsSinceDays: [
                { value: null, text: 'N/A' },
                { value: 365, text: 'last 1 year' },
                { value: 730, text: 'last 2 years' }
            ],
            availableCategories: [
                { communicationsCategoryId: 'birthday', categoryAutomated: true, categoryEnabled: false },
                { communicationsCategoryId: 'newsletter', categoryAutomated: false, categoryEnabled: false },
                { communicationsCategoryId: 'seasonal', categoryAutomated: false, categoryEnabled: false },
                { communicationsCategoryId: 'recalls', categoryAutomated: true, categoryEnabled: false },
                { communicationsCategoryId: 'sale', categoryAutomated: false, categoryEnabled: false },
                { communicationsCategoryId: 'missed', categoryAutomated: true, categoryEnabled: false },
                { communicationsCategoryId: 'reviews', categoryAutomated: true, categoryEnabled: false },
                { communicationsCategoryId: 'latepayment', categoryAutomated: false, categoryEnabled: false },
                { communicationsCategoryId: 'shortnotice', categoryAutomated: false, categoryEnabled: false },
                { communicationsCategoryId: 'triggered', categoryAutomated: true, categoryEnabled: false },
                { communicationsCategoryId: 'survey', categoryAutomated: true, categoryEnabled: false }
            ],
            APPOINTMENT_TRIGGER: APPOINTMENT,
            ORDERS_TRIGGER: ORDERS,
            disableTriggerHoursDropDown: false,
            // Only for non escalate categories
            defaultSendRulesLeft: [
                { "rule": "stopOnSuccess", "mediaDestinatorType": "email" },
                { "rule": "stopOnSuccess", "mediaDestinatorType": "" },
                { "rule": "stopOnSuccess", "mediaDestinatorType": "" }
            ],
            defaultAppointmentState: { "appointmentState": null, "remoteAppointmentState": "Any appointment status" },
            defaultReason: { "reasonId": null, "reasonName": "Any appointment type" },
            defaultProvider: { "providerId": null, "providerName": "Any provider" },
            defaultSpecies: { "label": "Any Species", value: null },
            defaultBreed: { "label": "Any Breed", value: null },
            resetList: function () {
                service.jobs.list = [];
            },
            createDefaultJob: function (template) {
                // mediaTypesJSON
                // The job needs to have the template id for each media template
                // NOTE: Master templates MUST be collections and contain all media
                var media = template.mediaTypes.media;
                for (var j = 0; j < media.length; ++j) {
                    media[j].templateId = template.templateId;
                }
                var sendRules;
                if (template.communicationsCategoryId === 'recalls' || template.communicationsCategoryId === 'missed') {
                    sendRules = [
                        { "rule": "escalate", "mediaDestinatorType": "email" },
                        { "rule": "escalate", "mediaDestinatorType": "", "daysAfterFirst": 0 },
                        { "rule": "escalate", "mediaDestinatorType": "", "daysAfterFirst": 0 },
                        { "rule": "escalate", "mediaDestinatorType": "stop", "daysAfterFirst": 5 }
                    ];
                }
                else {
                    sendRules = angular.copy(service.defaultSendRulesLeft);
                }
                var defaultJob = {
                    "jobCategory": template.communicationsCategoryId,
                    "jobName": "",
                    "jobDescription": "",
                    "jobState": "draft",
                    "jobContent": {
                        "template": template.templateDefaultContent,
                        "media": media,
                        "mediaTypeMode": true,
                        "sendRules": sendRules,
                        // TODO: REMOVE
                        "jobMediaTypes": {
                            "priorities": [
                                { "rule": "stopOnSuccess", "media": "email" },
                                { "rule": "stopOnSuccess", "media": "none" },
                                { "rule": "stopOnSuccess", "media": "none" },
                            ],
                            "email": true,
                            "sms": false,
                            "voiceHome": false,
                            "voiceCell": false,
                            "voiceWork": false,
                            "voiceAlt": false
                        }
                    }
                };
                if (template.communicationsCategoryId === 'birthday') {
                    defaultJob.jobContent.targets = [{ "type": "birthday", "testTime": "2015-03-15 00:00:00", "range": "day", "gender": "" }];
                    defaultJob.jobContent.triggerSetting = { "triggerType": "hourOfDay", "triggerHour": 9 };
                }
                else if (template.communicationsCategoryId === 'sale' ||
                    template.communicationsCategoryId === 'seasonal' ||
                    template.communicationsCategoryId === 'newsletter') {
                    defaultJob.jobContent.targets = [{
                            "type": "appointmentDate",
                            "acceptAppointmentStates": ["scheduled", "confirmed", "completed", "missed"],
                            "gender": "",
                            "age": "",
                            "minAppointments": 0
                        }];
                }
                else if (template.communicationsCategoryId === 'survey') {
                    defaultJob.jobContent.triggerSetting = { "triggerType": "hourOfDay", "triggerHour": 9 };
                    defaultJob.jobContent.targets = [{
                            "type": "survey",
                            "minAppointments": 0
                        }]; // setting minAppointments to 0 to get distinct persons in scheduler
                }
                else if (template.communicationsCategoryId === 'reviews') {
                    defaultJob.jobContent.triggerSetting = { "triggerType": "hourOfDay", "triggerHour": 9 };
                    defaultJob.jobContent.targets = [{
                            "type": "reviews",
                            "minAppointments": 0
                        }]; // setting minAppointments to 0 to get distinct persons in scheduler
                }
                else if (template.communicationsCategoryId === 'missed') {
                    defaultJob.jobContent.triggerSetting = { "triggerType": "hourOfDay", "triggerHour": 9 };
                    defaultJob.isValid = false;
                    // Create first target with job parameters only set on first target
                    // Accepted states are for new appointments while remoteAppointmentState is for the old appointment triggering recall
                    defaultJob.jobContent.targets = [{
                            "type": "missed",
                            "remoteAppointmentState": null,
                            //"acceptAppointmentStates" : ["scheduled", "confirmed"],
                            "minAppointments": 1,
                            "scanDaysBack": 1,
                            "scanDaysForward": 90
                        }];
                }
                else if (template.communicationsCategoryId === 'recalls') {
                    defaultJob.jobContent.triggerSetting = { "triggerType": "hourOfDay", "triggerHour": 9 };
                    defaultJob.isValid = false;
                    // Create first target with job parameters only set on first target
                    // Accepted states are for new appointments while remoteAppointmentState is for the old appointment triggering recall
                    defaultJob.jobContent.targets = [{
                            "type": "recalls",
                            "remoteAppointmentState": null,
                            //"acceptAppointmentStates" : ["scheduled", "confirmed"],
                            "minAppointments": 1,
                            "recallInterval": 1,
                            "scanDaysBack": 365,
                            "scanDaysForward": 90
                        }];
                    defaultJob.jobContent.type = "recalls"; // TODO: Check if this is needed
                    defaultJob.jobContent.jobMediaTypes.priorities[1].daysAfterFirst = '';
                    defaultJob.jobContent.jobMediaTypes.priorities[2].daysAfterFirst = '';
                }
                else if (template.communicationsCategoryId === 'triggered') {
                    defaultJob.jobContent.triggerSetting = { "triggerType": "hourOfDay", "triggerHour": 9 };
                    defaultJob.isValid = false;
                    // Create first target with job parameters only set on first target
                    // Accepted states are for new appointments while remoteAppointmentState is for the old appointment triggering recall
                    defaultJob.jobContent.targets = [{
                            "type": "triggered",
                            "remoteAppointmentState": null,
                            "acceptAppointmentStates": ["scheduled", "confirmed"],
                            "triggerOffset": 1
                        }];
                }
                return defaultJob;
            },
            jobStatusLabel: function (state) {
                if (state === 'draft')
                    return 'Draft';
                else if (state === 'queued' || state === 'dequeued')
                    return 'In progress';
                else if (state === 'sent' || state === 'done')
                    return 'Done';
                else if (state === 'disabled')
                    return 'Disabled';
                else if (state === 'paused')
                    return 'Paused';
                else
                    return 'Unknown (' + state + ')';
            },
            selectCategory: function (templateCategory) {
                if (!templateCategory.categoryEnabled) {
                    var dialog = dialogs.create('app/communication/communications.feature.dialog.html', 'autoremind.communications.FeatureDialogController', { communicationsCategory: templateCategory }, { key: false, back: 'static' });
                    dialog.result.then(function (jobId) {
                        // Confirm
                    }, function () {
                        // Cancel
                    });
                    //dialogs.notify('Note', 'This is not available.');
                    return;
                }
                if (angular.isDefined(templateCategory.isNoTemplate) && templateCategory.isNoTemplate && templateCategory.communicationsCategoryId !== 'latepayment') {
                    dialogs.notify('Warning', 'No templates (' + templateCategory.communicationsCategoryId + ') has been assigned yet.');
                    return;
                }
                if (!templateCategory.job && templateCategory.communicationsCategoryId !== 'latepayment') {
                    templateCategory.job = {
                        data: {}
                    };
                }
                if (service.isAutomatedCategory(templateCategory.communicationsCategoryId)) {
                    service.resetList();
                }
                service.selectedCategoryId = templateCategory.communicationsCategoryId;
                // TODO: Notify if enabled but no templates
                //            dialogs.error('Server Problem', 'There was a problem getting list of automated messages from the server.');
                /*if (templateCategory.job && angular.isDefined(templateCategory.job.jobCategory) && templateCategory.job.jobCategory === 'survey') {
                    //templateCategory.job.jobContent.template.surveyResultUrl = '';
                }*/
                if (angular.isDefined(service.selectedCategory) && service.selectedCategory !== null && service.job.edited) {
                    var dialog = dialogs.confirm('Confirm', 'Unsaved changes will be lost! Are you sure you want to create a new message without saving first?');
                    dialog.result.then(function (button) {
                        // Yes
                        service.confirmedSelectCategory(templateCategory);
                    }, function (button) {
                        // No
                        event.preventDefault();
                    });
                }
                else {
                    service.confirmedSelectCategory(templateCategory);
                }
            },
            confirmedSelectCategory: function (templateCategory) {
                service.selectedCategory = templateCategory;
                service.selectedBreed = null;
                service.selectedSpecies = null;
                if (angular.isDefined(templateCategory.job)) {
                    // If type is automated message then load all similar jobs to display
                    // Initiate this before setting current job to get and display list before calculating stats
                    if (service.isAutomatedCategory(templateCategory.job.jobCategory)) {
                        service.jobs.getJobs(templateCategory.communicationsCategoryId)
                            .then(null, function (reason) {
                            dialogs.error('Server Problem', 'There was a problem getting list of automated messages from the server.');
                        });
                    }
                    // Add copy ready to edit (leaving original job template from categories list intact)
                    var promise = service.setCurrentJob(angular.copy(templateCategory.job), true);
                    //$scope.selectTemplate($scope.job.data.templateId);
                    promise.then(function () {
                        storeDowngraded.dispatch(PreviewEditTemplateActions.getModel({ templateId: service.template.templateId }));
                    });
                }
            },
            templateContextFormat: function (tData, type) {
                var updatedValue = { isModelUpdated: false, value: tData };
                if (tData !== null &&
                    (tData.toString().indexOf("<comment") !== -1 ||
                        tData.toString().indexOf("comment>") !== -1) &&
                    type === "db") {
                    updatedValue.isModelUpdated = true;
                }
                if (tData !== null) {
                    var value = tData.toString()
                        .replaceAll("<comment", "<template-context")
                        .replaceAll("comment>", "template-context>")
                        .replaceAll("<br/>", "<br>")
                        .replaceAll("/>", "></template-context>")
                        .replaceAll("<br>", "<br/>");
                    updatedValue.value = value;
                }
                return updatedValue;
            },
            inProgress: false,
            getJobs: function (model, jobCategory, jobId) {
                model.last = 0;
                $log.debug('jobService.getJobs(offset=' + model.last + ')');
                return service.getMoreJobs(model, jobCategory, jobId);
            },
            getMoreJobs: function (model, jobCategory, jobId) {
                var deferred = $q.defer();
                //                if (!service.inProgress) {
                service.inProgress = true;
                $log.debug('jobService.getMoreJobs(offset=' + model.last + ')' + jobCategory);
                var url;
                if (jobCategory === undefined || jobCategory === null) {
                    url = '/servlets/jobs/communications/all/?offset=' + model.last;
                }
                else {
                    url = '/servlets/jobs/communications/' + jobCategory + '/?offset=' + model.last;
                }
                if (jobId) {
                    url += '&jobId=' + jobId;
                }
                $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    disableErrorDialog: false,
                    errorMessage: 'Error getting jobs data from server.'
                })
                    .then(function (data, status) {
                    for (var i = 0; i < data.jobs.length; i++) {
                        // Only add new elements if not already in the list
                        var alreadyInList = false;
                        var t;
                        for (var j = 0; j < model.list.length; j++) {
                            if (model.list[j].jobId === data.jobs[i].jobId) {
                                alreadyInList = true;
                                t = j;
                                break;
                            }
                        }
                        if (alreadyInList) {
                            // Renew an existent job item
                            model.list[t] = data.jobs[i];
                        }
                        else {
                            model.list.push(data.jobs[i]);
                        }
                        model.last++;
                    }
                    service.inProgress = false;
                    return data;
                }, function (data, status) {
                    service.inProgress = false;
                    $log.error('Error getting jobs data from server: ' + data.error);
                    deferred.reject(status);
                })
                    .then(function (result) {
                    service.recalcAutomatedJobs();
                    deferred.resolve(result);
                    service.job.setEdited(false);
                });
                //                } else {
                //                    $log.debug("skipping - in progress");
                //                }
                return deferred.promise;
            },
            getMessagesSentStats: function (jobCategory, jobId) {
                var deferred = $q.defer();
                service.inProgress = true;
                $log.debug('jobService.getMessagesSentStats():' + jobCategory);
                var url = '/servlets/jobs/communications/' + jobCategory + '/messagessentstats/';
                if (jobId) {
                    url += '?jobId=' + jobId;
                }
                $enhancedHttp({
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    disableErrorDialog: false,
                    errorMessage: 'Error getting messages sent stats from server.'
                })
                    .then(function (data, status) {
                    service.inProgress = false;
                    return data;
                }, function (data, status) {
                    service.inProgress = false;
                    $log.error('Error getting jobs data from server: ' + data.error);
                    deferred.reject(status);
                })
                    .then(function (result) {
                    deferred.resolve(result);
                });
                return deferred.promise;
            },
            /**
             * Get automated jobs by CategoryId
             */
            loadJobs: function (communicationsCategoryId) {
                if (arguments.length === 0)
                    communicationsCategoryId = service.selectedCategoryId;
                return service.jobs.getJobs(communicationsCategoryId)
                    .then(function (response) {
                    return $filter('filter')(response.jobs, service.activeAutomatedJob);
                });
            },
            activeAutomatedJob: function (job) {
                if (!service.isAutomatedCategory(job.jobCategory))
                    return false;
                if (!service.isActiveJob(job.jobState))
                    return false;
                return true;
            },
            getReasonById: function (reasonId) {
                if (reasonId === null)
                    return service.defaultReason.reasonName;
                if (service.reasons !== undefined && reasonId !== undefined) {
                    for (var i = 0; i < service.reasons.length; ++i) {
                        if (service.reasons[i].reasonId === reasonId) {
                            return service.reasons[i].reasonName;
                        }
                    }
                }
                return service.defaultReason.reasonName;
            },
            // ----------------------------------------------------------------------
            // model
            jobs: {
                last: 0,
                inProgress: function () {
                    return service.inProgress;
                },
                list: [],
                getJobs: function (jobCategory) {
                    return service.getJobs(this, jobCategory);
                },
                getMoreJobs: function (jobCategory) {
                    return service.getMoreJobs(this, jobCategory);
                }
            },
            /**
             * When called by the Communications page it returns a promise of service.job.updateTargetStats().
             */
            setCurrentJob: function (jobData, isForCommunicationPage) {
                service.jobPreviousName = jobData.jobName;
                service.job.data = jobData;
                service.job.jobContent = service.job.data.jobContent; // Map for shorthand reference
                // When loading template via ng-include it will replace template variables due to model bindings
                // in the template so later we use lateJobContent to once again update the variables
                //JULY2: this does not seem to be the case anymore!
                service.job.lateJobContent = service.job.data.jobContent;
                service.job.isAutomatedCategory = service.isAutomatedCategory(jobData.jobCategory);
                service.job.setEdited(false);
                service.job.editable = true;
                service.job.jobConfirm = false;
                if (jobData.jobState === 'draft') {
                    service.job.jobConfirm = false;
                    service.job.editable = true;
                }
                else if (jobData.jobState === 'queued' || jobData.jobState === 'dequeued' || jobData.jobState === 'paused' || jobData.jobState === 'manual') {
                    service.job.jobConfirm = true;
                    if (service.job.isAutomatedCategory) {
                        // If job is a repeated job (e.g. birthdays) then it should still be editable
                        service.job.editable = true;
                    }
                    else {
                        service.job.editable = false;
                    }
                }
                else {
                    service.job.editable = false;
                }
                // Map to data properties, though they are still available in the data object (service.job.data) to be sent directly to the backend
                service.job.jobId = jobData.jobId;
                //service.job.name = jobData.name + "AAA";
                //service.job.description = jobData.description;
                //service.job.targets = jobData.jobContent.targets; // TODO: Rename templateDefaultContent to meta in database
                // If called from the reports page - don't get more data and don't return a promise
                if (!isForCommunicationPage)
                    return;
                // New jobs may not have targets defined yet (especially job templates)
                if (jobData.jobContent.targets === undefined || jobData.jobContent.targets === null) {
                    jobData.jobContent.targets = [];
                }
                else {
                    if (jobData.jobContent.targets.length > 0) {
                        //job.jobContent.triggerSetting.triggerType
                        //service.job.targets[0].type == 'birthday'
                        var target = jobData.jobContent.targets[0];
                        service.job.setGender(target.gender);
                        service.job.setPetGender(target.petGender);
                        service.job.setAgeFilter(target.age);
                        service.job.setPetAgeFilter(target.petAge);
                        service.job.setAppointmentSince(target.appointmentSince);
                        console.log('jobData.jobCategory', jobData.jobCategory, '-----', target, '-----');
                        if (target.petSpecies !== undefined) {
                            service.selectedSpecies = target.petSpecies;
                        }
                        if (target.petBreed !== undefined) {
                            service.selectedBreed = target.petBreed;
                        }
                        if (jobData.jobCategory === 'sale' || jobData.jobCategory === 'seasonal' || jobData.jobCategory === 'newsletter') {
                            service.selectedLocation = target.location || "Any location";
                            service.selectedProviderId = target.providerId || null;
                            service.selectedReasonId = target.reasonId || null;
                            service.job.appointmentsSinceDaysAgo = target.appointmentsSinceDaysAgo || null;
                            service.job.minAppointments = target.minAppointments || 0; // Default is "N/A" (-1) - though default is defined in controller initialization
                            // For now, clients in target group must have pets,
                            // otherwise pet variables set in the job message might not be available when sending the communication
                            if (service.isVets) {
                                target.clientMustHavePets = true;
                            }
                            // If no appointments, then don't send period
                            if (service.job.minAppointments !== 0) {
                                service.job.targetDateFrom = moment(target.from, 'YYYY-MM-DD').toDate() || moment().add(-1, 'years').format("YYYY-MM-DD"); // -1 year
                                service.job.targetDateTo = moment(target.to, 'YYYY-MM-DD').toDate() || moment().format("YYYY-MM-DD"); // today
                                if (target.from === undefined) {
                                    target.from = service.job.targetDateFrom;
                                }
                                if (target.to === undefined) {
                                    target.to = service.job.targetDateTo;
                                }
                            }
                        }
                        else if (jobData.jobCategory === 'survey' || jobData.jobCategory === 'reviews') {
                            service.selectedRemoteAppointmentState = target.remoteAppointmentState || service.defaultAppointmentState.appointmentState;
                            service.selectedProviderId = target.providerId || null;
                            service.selectedReasonId = target.reasonId || null;
                            service.job.minAppointments = target.minAppointments || 1;
                            service.job.maxMessages = target.maxMessages || 2;
                            service.job.maxMessagesDaysBack = target.maxMessagesDaysBack || 30;
                        }
                        else if (jobData.jobCategory === 'recalls') {
                            service.selectedRemoteAppointmentState = target.remoteAppointmentState || service.defaultAppointmentState.appointmentState;
                            service.selectedReasonId = target.reasonId || null;
                            service.job.minAppointments = target.minAppointments || 1;
                        }
                        else if (jobData.jobCategory === 'missed' || jobData.jobCategory === 'triggered') {
                            service.selectedRemoteAppointmentState = target.remoteAppointmentState || service.defaultAppointmentState.appointmentState;
                            service.selectedReasonId = target.reasonId || null;
                            service.selectedProviderId = target.providerId || null;
                            service.job.minAppointments = target.minAppointments || 1;
                        }
                        else if (jobData.jobCategory === 'shortnotice') {
                            service.job.appointmentsSinceDaysAgo = target.appointmentsSinceDaysAgo || null;
                        }
                        else if (jobData.jobCategory === 'birthday') {
                            // For now, clients in target group must have pets,
                            // otherwise pet variables set in the job message might not be available when sending the communication
                            if (service.isVets) {
                                target.clientMustHavePets = true;
                            }
                        }
                    }
                }
                service.job.targets = jobData.jobContent.targets;
                if (service.job.isAutomatedCategory) {
                    // TODO: if service.job.triggerSetting.triggerHour defined
                    service.job.setTriggerOffsetMinutes(jobData.jobContent.triggerSetting.triggerOffsetMinutes);
                    service.job.setHourOfDay(jobData.jobContent.triggerSetting.triggerHour);
                    service.job.setDayOfMonth(jobData.jobContent.triggerSetting.triggerDay);
                }
                service.job.initFromTemplates(true);
                //service.template = jobData.jobContent.template;
                // Set a timestamp to use for change watcher on template model to know it's a new template
                var date = new Date();
                service.startTime = date.getTime();
                service.jobFormDirty = false;
                var changed = false;
                service.job.calculateMediaType(changed);
                var templateUpdateModel = { updatedModel: jobData.jobContent.template, isModelUpdated: false, updateType: 'setToDefault' };
                service.templateUpdateModel = templateUpdateModel;
                var deferred = $q.defer();
                deferred.resolve(true);
                return deferred.promise; // service.job.updateTargetStats(); // getting results from backend will trigger update of UI (controller watching targetStats)
            },
            lateUpdate: function () {
                // Map template variables to service.template for easy access especially in templates
                // This will also replace any default values set above
                for (var key in service.job.lateJobContent.template) {
                    if (service.job.lateJobContent.hasOwnProperty(key)) {
                        var value = service.job.lateJobContent.template[key];
                        // TODO: check if already present and replace
                        service.template[key] = value;
                    }
                }
            },
            hasJob: function () {
                return service.job.data !== null ? true : false;
            },
            deleteJob: function (jobId) {
                service.inProgress = true;
                $enhancedHttp({
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/jobs/' + jobId + '/',
                    disableErrorDialog: false,
                    errorMessage: 'Error deleting job by server.'
                })
                    .then(function (response, status) {
                    service.inProgress = false;
                    $log.debug('jobService.job.deleteJob(' + jobId + ') handled by server : ' + status);
                    // Remove job from list of displayed jobs
                    for (var j = 0; j < service.jobs.list.length; j++) {
                        var job = service.jobs.list[j];
                        if (job.jobId === jobId) {
                            job.jobState = 'deleted'; // This will make the job invisible in the UI's list
                            //service.jobs.list = service.jobs.list.splice(j, 1);
                            // If we're deleting the job actively displayed/edited we also mark this deleted so the UI will hide it
                            if (service.job.jobId === jobId) {
                                service.job.data.jobState = 'deleted';
                            }
                            return;
                        }
                    }
                }, function (data, status) {
                    service.inProgress = false;
                    $log.error('Error deleting job by server');
                    //deferred.reject(status);
                });
            },
            showMessageDetails: function (jobId) {
                var modalInstance;
                var modalScope = $rootScope.$new();
                var self = this;
                modalScope.jobId = jobId;
                modalScope.success = function (result) {
                    modalInstance.close(modalScope.selected);
                };
                modalScope.cancel = function () {
                    modalInstance.dismiss('cancel');
                };
                modalInstance = $uibModal.open({
                    template: '<messaging-details></messaging-details>',
                    size: 'lg',
                    scope: modalScope,
                    backdrop: 'static'
                });
            },
            disableJob: function (jobId) {
                service.inProgress = true;
                return $enhancedHttp({
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json' },
                    url: '/servlets/jobs/' + jobId + '/' + '?disableautomation=1',
                    disableErrorDialog: false,
                    errorMessage: 'Error disabling job by server.'
                })
                    .then(function (response, status) {
                    service.inProgress = false;
                    $log.debug('jobService.job.disableJob(' + jobId + ') handled by server : ' + status);
                    // Remove job from list of displayed jobs
                    for (var j = 0; j < service.jobs.list.length; j++) {
                        var job = service.jobs.list[j];
                        if (job.jobId === jobId) {
                            job.jobState = 'disabled'; // This will make the job invisible in the UI's automated list
                            //job.data.jobState = 'disabled'; // This will make the job invisible in the UI's automated list
                            //service.jobs.list = service.jobs.list.splice(j, 1);
                            break;
                        }
                    }
                    return true;
                })
                    .then(function (result) {
                    service.recalcAutomatedJobs();
                    return result;
                })
                    .catch(function (error) {
                    service.inProgress = false;
                    $log.error('Error disabling job by server');
                    service.recalcAutomatedJobs();
                });
            },
            recalcAutomatedJobs: function () {
                var queuedJobsCount = 0;
                if (angular.isDefined(service.selectedCategory) &&
                    service.selectedCategory != null &&
                    (angular.isDefined(service.selectedCategory.communicationsCategoryId) || angular.isDefined(service.selectedCategoryId)) &&
                    (service.selectedCategory.communicationsCategoryId != null || service.selectedCategoryId != null) &&
                    angular.isDefined(service.selectedCategory.automatedJobs)) {
                    var CategoryId = service.selectedCategory.communicationsCategoryId || service.selectedCategoryId;
                    if (service.isAutomatedCategory(CategoryId)) {
                        service.jobs.list.forEach(function (job, index) {
                            if (job.jobCategory == CategoryId && job.jobState == 'queued') {
                                queuedJobsCount++;
                            }
                        });
                        service.selectedCategory.automatedJobs = queuedJobsCount;
                    }
                }
            },
            pauseResumeJob: function (jobId, state) {
                var url = '/servlets/jobs/' + jobId + '/state/';
                return $enhancedHttp({
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    url: url,
                    errorMessage: 'Failed saving the state.',
                    disableErrorDialog: true,
                    data: {
                        jobState: state
                    }
                });
            },
            isActiveJob: function (state) {
                return !(state === 'draft' || state === 'deleted' || state === 'disabled');
            },
            isAutomatedCategory: function (category) {
                return (category === 'birthday' ||
                    category === 'missed' ||
                    category === 'recalls' ||
                    category === 'triggered' ||
                    category === 'survey' ||
                    category === 'reviews');
            },
            setProviders: function (providers) {
                service.providers = [...providers];
            },
            getProviders: function () {
                return service.providers;
            },
            setReasons: function (reasons) {
                service.reasons = [...reasons];
            },
            getReasons: function () {
                return service.reasons;
            },
            // ----------------------------------------------------------------------
            // TODO: if cloning a job no longer draft - make sure to clear all
            // TODO: if trying to clone a job with changes - ask if we should save changes first?
            // TODO: not possible to clone a new job with no edits
            job: {
                data: null,
                jobChanged: false,
                isAutomatedCategory: false,
                editable: true,
                jobConfirm: false,
                edited: false,
                clonable: false,
                targets: [],
                targetStats: {},
                isValid: true,
                inProgress: false,
                statsInProgress: false,
                //jobId: 0,
                //categoryId: '',
                //name: '',
                //description: '',
                targetDateFrom: moment().format("YYYY-MM-DD"),
                targetDateTo: moment().format("YYYY-MM-DD"),
                // ONLY use this for UI to show loading indicators - not to check if job.inProgress is true/false
                isInProgress: function () {
                    return service.job.inProgress || service.job.statsInProgress;
                },
                getJob: function (jobId) {
                    var deferred = $q.defer();
                    if (!service.job.inProgress) {
                        service.job.inProgress = true;
                        // var self = this;
                        $log.debug('jobService.job.getJob(' + jobId + ')');
                        service.job.data = null;
                        $enhancedHttp({
                            method: 'GET',
                            headers: { 'Content-Type': 'application/json' },
                            url: '/servlets/jobs/' + jobId + '/',
                            disableErrorDialog: false,
                            errorMessage: 'Error getting jobs data from server.'
                        })
                            .then(function (response, status) {
                            $log.debug('jobService.job.getJob(' + jobId + ') got data from server ' + status);
                            var smsMessage = response.job.jobContent.template.smsMessage;
                            if (smsMessage !== undefined && smsMessage !== null) {
                                // Strip html tags (<div><br /></div> are inserted for newline)
                                // TODO: convert &nbsp;
                                // Replace <br> and <br/> and <br /> with \n
                                smsMessage = smsMessage.replace(/(\n)/g, '<div><br/></div>');
                                response.job.jobContent.template.smsMessage = smsMessage;
                            }
                            if (response.job.jobCategory === "recalls") {
                                // In order to account for appointments on the day of recallInterval days ago regardless of the time of day, we look back one day less than UI indicates
                                response.job.jobContent.targets[0].recallInterval += 1;
                                // NOTE: We deduct 1 day before saving job
                            }
                            service.job.inProgress = false;
                            response.job.jobContent.template.templateId = response.job.jobContent.media[0].templateId;
                            var promise = service.setCurrentJob(response.job, true);
                            promise.then(function () {
                                deferred.resolve(response);
                            }, function (reason) {
                                deferred.resolve(response);
                            });
                        }, function (data, status) {
                            service.job.inProgress = false;
                            $log.error('Error getting jobs data from server');
                            deferred.reject(status);
                        });
                    }
                    else {
                        $log.debug("skipping - in progress");
                    }
                    return deferred.promise;
                },
                getJobReport: function (jobId) {
                    var deferred = $q.defer();
                    if (!service.job.inProgress) {
                        service.job.inProgress = true;
                        $log.debug('jobService.job.getJobReport(' + jobId + ')');
                        service.job.data = null;
                        $enhancedHttp({
                            method: 'GET',
                            headers: { 'Content-Type': 'application/json' },
                            url: '/servlets/jobs/' + jobId + '/',
                            disableErrorDialog: false,
                            errorMessage: 'Error getting jobs data from server.'
                        })
                            .then(function (response, status) {
                            $log.debug('jobService.job.getJobReport(' + jobId + ') got data from server ' + status);
                            service.job.inProgress = false;
                            service.setCurrentJob(response.job, false); // false to avoid getting all data for needed only for the Communications page
                            deferred.resolve(response);
                        }, function (data, status) {
                            service.job.inProgress = false;
                            $log.error('Error getting jobs data from server');
                            deferred.reject(status);
                        });
                    }
                    else {
                        $log.debug("skipping - in progress");
                    }
                    return deferred.promise;
                },
                clone: function () {
                    if (service.job.edited) {
                        var dialog = dialogs.confirm('Confirm', 'Unsaved changes will be lost! Are you sure you want to create a copy without saving first?');
                        dialog.result.then(function (button) {
                            // Yes
                            service.job.checkIfNew();
                        }, function (button) {
                            // No
                            event.preventDefault();
                            return;
                        });
                    }
                    else {
                        service.job.checkIfNew();
                    }
                },
                checkIfNew: function () {
                    var data = {
                        'jobId': service.job.data.jobId,
                        'jobCategory': service.job.data.jobCategory,
                        'template': service.job.jobContent.template,
                        'templateId': service.job.jobContent.media[0].templateId
                    };
                    // Call backend and check if model is latest
                    $enhancedHttp({
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        url: '/servlets/jobs/checkIfLatest/',
                        data: data,
                        disableErrorDialog: true,
                        errorMessage: 'Error saving job data on the server'
                    })
                        .then(function (response) {
                        if (response.isKeysDifferent === 'true') {
                            var dialog = dialogs.confirm('Confirm', 'Copied template is using an old version, it might not be supported. Do you still want to continue?');
                            dialog.result.then(function (button) {
                                // Yes
                                service.job.confirmedClone();
                            }, function (button) {
                                // No
                                event.preventDefault();
                            });
                        }
                        else {
                            service.job.confirmedClone();
                        }
                    }, function (data, status) {
                        service.job.inProgress = false;
                        $log.error('Error copying job data');
                        dialogs.error('Server Problem', 'Error saving the message!');
                        event.preventDefault();
                    });
                },
                confirmedClone: function () {
                    service.job.data.jobId = undefined;
                    service.job.data.jobName = 'Copy of ' + service.job.data.jobName;
                    service.job.data.jobState = 'draft';
                    service.job.setEdited(false);
                    service.job.editable = true;
                    // TODO: Ensure that all data related to old job is reset
                },
                sanitizeTemplate: function (dataCopy) {
                    var smsMessage = dataCopy.smsMessage;
                    if (smsMessage !== undefined && smsMessage != null) {
                        // Replace characters not in SMS ASCII
                        smsMessage = smsMessage.replace("´", '\'');
                        smsMessage = smsMessage.replace("“", '\"');
                        smsMessage = smsMessage.replaceAll("&", "&amp;");
                        dataCopy.smsMessage = smsMessage;
                    }
                    var emailSubject = dataCopy.emailSubject;
                    emailSubject = emailSubject.replace(/\&nbsp[;]?/g, ' ');
                    emailSubject = emailSubject.toString().replaceAll("&", "&amp;");
                    dataCopy.emailSubject = emailSubject;
                    return dataCopy;
                },
                save: function () {
                    var deferred = $q.defer();
                    if (!service.job.isValid) {
                        dialogs.notify('Note', 'Please input all required fields!');
                        return deferred.reject(status);
                    }
                    if (service.job.data.jobName === '') {
                        dialogs.notify('Note', 'You must give the message a name!');
                        return deferred.reject(status);
                    }
                    else {
                        if (service.job.data.jobCategory === 'recalls' && service.job.data.jobContent.targets[0].recallInterval < 1) {
                            dialogs.notify('Note', 'The recall interval must be at least 1 day!');
                            return deferred.reject(status);
                        }
                        // Do not allow saving if we're waiting for results from backend
                        if (!service.job.inProgress) {
                            service.job.inProgress = true;
                            // TODO: keep track of when a job in the list has been saved and mark it so
                            var url = '/servlets/jobs/' + (service.job.data.jobId !== undefined ? service.job.data.jobId + '/' : '');
                            //filter all html formatting and HTML encoding
                            // service.template.emailSubject = service.sanitizeEmailSubject(service.template.emailSubject);
                            // Put active (and perhaps edited) template model into the data to be saved in database
                            service.job.data.jobContent.template = service.template;
                            //TODO: why this.data.jobContent and not just service.job.jobContent?
                            if (service.job.isAutomatedCategory) {
                                if (service.job.jobContent.triggerSetting.triggerType === 'hourOfDay') {
                                    service.job.jobContent.targets[0].range = 'day';
                                }
                                else if (service.job.jobContent.triggerSetting.triggerType === 'dayOfMonth') {
                                    service.job.jobContent.targets[0].range = 'month';
                                }
                                if (service.job.data.jobCategory === 'survey' || service.job.data.jobCategory === 'reviews') {
                                    service.job.jobContent.targets[0].maxMessages = service.job.maxMessages;
                                    service.job.jobContent.targets[0].maxMessagesDaysBack = service.job.maxMessagesDaysBack;
                                }
                                else if (service.job.data.jobCategory === 'birthday') {
                                    service.job.jobContent.targets[0].age = service.job.jobTargetAge;
                                }
                            }
                            // Create copy that can be manipulated before saving
                            var jobDataCopy = angular.copy(service.job.data);
                            if (jobDataCopy.jobCategory === 'recalls') {
                                // In order to account for appointments on the day of recallInterval days ago regardless of the time of day, we look back one day less
                                jobDataCopy.jobContent.targets[0].recallInterval -= 1;
                                // NOTE: We add 1 day after loading job before showing in UI
                            }
                            else if (jobDataCopy.jobCategory === "missed") {
                                jobDataCopy.jobContent.targets[0].scanDaysBack = jobDataCopy.jobContent.sendRulesLeft[3].daysAfterFirst;
                            }
                            jobDataCopy.jobContent.template = eventSharingService.validateTemplateBeforeSave(jobDataCopy.jobContent.template);
                            // service.job.sanitizeSMS(jobDataCopy);
                            $enhancedHttp({
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                url: url,
                                data: jobDataCopy,
                                disableErrorDialog: true,
                                errorMessage: 'Error saving job data on the server'
                            })
                                .then(function (response, status) {
                                service.job.inProgress = false;
                                $log.debug('Job [' + response.job.jobId + '] saved.');
                                service.job.data.jobId = response.job.jobId;
                                service.job.jobId = response.job.jobId;
                                service.job.edited = false;
                                //service.job.clonable = true;
                                //service.job.jobConfirm = false;
                                // If type is automated message then load all similar jobs to display
                                if (service.job.isAutomatedCategory) {
                                    service.jobs.getJobs(service.job.data.jobCategory)
                                        .then(null, function (reason) {
                                        dialogs.error('Server Problem', 'There was a problem getting list of automated messages from the server.');
                                        deferred.resolve(response.job);
                                    }, function () {
                                        deferred.resolve(response.job);
                                    });
                                }
                                else {
                                    deferred.resolve(response.job);
                                }
                            }, function (data, status) {
                                service.job.inProgress = false;
                                $log.error('Error saving job data on the server');
                                dialogs.error('Server Problem', 'Error saving the message!');
                                deferred.reject(status);
                            });
                        }
                        else {
                            $log.debug("skipping - in progress");
                        }
                    } // end if name given
                    return deferred.promise;
                },
                setEdited: function (edited) {
                    service.job.edited = edited;
                    // If the job is new and never saved - and not edited then cloning should be disabled
                    if (service.job.data !== null && service.job.data.jobId === undefined && !edited) {
                        service.job.clonable = false;
                    }
                    else {
                        service.job.clonable = true;
                    }
                },
                initFromTemplates: function (fromJob) {
                    // Set the template that will initiate loading template content into the template views
                    // - and overriding the template model with defaults from the template table in the database
                    for (var i = 0; i < service.job.jobContent.media.length; i++) {
                        var media = service.job.jobContent.media[i];
                        service.template.templateId = media.templateId;
                    }
                    // Map template variables to service.template for easy access especially in templates
                    // This will also replace any default values set above
                    // NOTE: First time around the service.template will contain default values from the job (not from the template)
                    // TODO: Consider if the default values in the template file should only be used to avoid errors (and thus leave with empty dummy values or use to set default values in database when adding new template (and on reqeust in admin)
                    // Scenario 1: called after loading/selecting job - we want values from jobContent (though adding values not yet set in job - if that is possible)
                    // Scenario 2: called after selecting different template - use values from template (discard all old values?)
                    // In case (fromJob=false) switching template we'll use the default values from the new template (discard values from the job)
                    if (!fromJob) {
                        var templateDefaultContent;
                        for (var j in service.templates.list) {
                            var template = service.templates.list[j];
                            if (service.template.templateId === template.templateId) {
                                templateDefaultContent = template.templateDefaultContent;
                                service.job.data.jobContent.template = templateDefaultContent;
                                break;
                            }
                        }
                    }
                    for (var key in service.job.data.jobContent.template) {
                        if (service.job.data.jobContent.template.hasOwnProperty(key)) {
                            var value = service.job.data.jobContent.template[key];
                            // TODO: check if already present and replace
                            service.template[key] = value;
                        }
                    }
                    // Remove keys not present in new template
                    for (var key in service.template) {
                        if (!service.job.data.jobContent.template.hasOwnProperty(key) && key !== 'templateId' && key !== 'templateUrl' && key !== 'voiceTemplateUrl') {
                            delete service.template[key];
                        }
                    }
                },
                setTemplates: function (template, mediaType, templateUpdateModel) {
                    // Traverse all medias for active job and update to selected template
                    for (var i = 0; i < service.job.jobContent.media.length; i++) {
                        var jobMedia = service.job.jobContent.media[i];
                        // Traverse medias of selected template and update either for each type ('collection') or only selected type
                        for (var j = 0; j < template.mediaTypes.media.length; j++) {
                            var newTemplateMedia = template.mediaTypes.media[j];
                            if (jobMedia.type === newTemplateMedia.type) {
                                //if (mediaType === 'collection' || jobMedia.type === mediaType) {
                                jobMedia.templateFragment = newTemplateMedia.templateFragment;
                                jobMedia.device = newTemplateMedia.device;
                                jobMedia.templateId = template.templateId;
                                service.template.templateId = jobMedia.templateId;
                                //}
                            }
                        }
                    }
                    // TODO: Check if new template has different/fewer/more variables than currently edited then warn user (before accepting new template?)
                    service.job.initFromTemplates(false);
                    service.job.setEdited(true);
                    var updatedModel = angular.copy(templateUpdateModel);
                    updatedModel.updatedModel = template.templateDefaultContent;
                    service.templateUpdateModel = angular.copy(updatedModel);
                    // The copy from templateDefaultContent has no templateId so add that
                    service.templateUpdateModel.updatedModel.templateId = template.templateId;
                },
                sendRuleChanged: function (ruleIndex) {
                    if (service.job.jobContent.sendRulesLeft[0].rule !== 'escalate')
                        return;
                    if (ruleIndex === 1) {
                        if (service.job.jobContent.sendRulesLeft[1].mediaDestinatorType !== null
                            && service.job.jobContent.sendRulesLeft[1].mediaDestinatorType !== '') {
                            if (service.job.jobContent.sendRulesLeft[1].daysAfterFirst < 1) {
                                service.job.jobContent.sendRulesLeft[1].daysAfterFirst = 1;
                            }
                        }
                        else {
                            service.job.jobContent.sendRulesLeft[1].daysAfterFirst = 0;
                            service.job.jobContent.sendRulesLeft[2].mediaDestinatorType = "";
                            service.job.jobContent.sendRulesLeft[2].daysAfterFirst = 0;
                        }
                    }
                    else if (ruleIndex === 2) {
                        if (service.job.jobContent.sendRulesLeft[2].mediaDestinatorType !== ""
                            && service.job.jobContent.sendRulesLeft[2].mediaDestinatorType !== '') {
                            if (service.job.jobContent.sendRulesLeft[2].daysAfterFirst < service.job.jobContent.sendRulesLeft[1].daysAfterFirst) {
                                service.job.jobContent.sendRulesLeft[2].daysAfterFirst =
                                    service.job.jobContent.sendRulesLeft[1].daysAfterFirst + 1;
                            }
                        }
                        else {
                            service.job.jobContent.sendRulesLeft[2].mediaDestinatorType = "";
                            service.job.jobContent.sendRulesLeft[2].daysAfterFirst = 0;
                        }
                    }
                    else if (ruleIndex === 3) {
                        //if (service.job.jobContent.sendRulesLeft[3].includeToDo === null
                        //    || !service.job.jobContent.sendRulesLeft[3].includeToDo) {
                        //service.job.jobContent.sendRulesLeft[3].daysAfterFirst = 0;
                        //}
                    }
                    //if (service.job.jobContent.sendRulesLeft[3].includeToDo !== null
                    //&& service.job.jobContent.sendRulesLeft[3].includeToDo) {
                    var highestDaysAfter = 1;
                    if (service.job.jobContent.sendRulesLeft[2].daysAfterFirst >= highestDaysAfter) {
                        highestDaysAfter = service.job.jobContent.sendRulesLeft[2].daysAfterFirst + 1;
                    }
                    else if (service.job.jobContent.sendRulesLeft[1].daysAfterFirst >= highestDaysAfter) {
                        highestDaysAfter = service.job.jobContent.sendRulesLeft[1].daysAfterFirst + 1;
                    }
                    if (service.job.jobContent.sendRulesLeft[3].daysAfterFirst < highestDaysAfter) {
                        service.job.jobContent.sendRulesLeft[3].daysAfterFirst = highestDaysAfter;
                    }
                    //}
                },
                mediaTypeChanged: function (ruleIndex) {
                    service.job.setEdited(true);
                    var changed = true;
                    if (ruleIndex > 0) {
                        service.job.sendRuleChanged(ruleIndex);
                    }
                    service.job.calculateMediaType(changed);
                    service.job.updateTargetStats(); // getting results from backend will trigger update of UI (controller watching targetStats)
                },
                /**
                 * Called with changed=true when destinator types edited. Otherwise, it's when loading the job.
                 */
                calculateMediaType: function (changed) {
                    // Calculate list of destinator types used
                    var use = [];
                    if (service.job.jobContent.mediaTypeMode) {
                        if (changed) { // TODO: Refactor to convert priorities if in loaded data (discard other if mediaTypeMode=true)
                            service.job.jobContent.sendRules = service.job.jobContent.sendRulesLeft;
                        }
                        else {
                            // This is when job was just loaded
                            service.job.jobContent.sendRulesRight = []; // Clear right side
                            service.job.jobContent.sendRulesLeft = service.job.jobContent.sendRules;
                            service.job.sendRuleChanged(0);
                        }
                    }
                    else {
                        if (changed) {
                            // Generate list used to send to backend
                            service.job.jobContent.sendRules = [];
                            for (var type in service.job.jobContent.sendRulesRight) {
                                if (service.job.jobContent.sendRulesRight[type]) {
                                    service.job.jobContent.sendRules.push({ "rule": "toAll", "mediaDestinatorType": type });
                                }
                            }
                        }
                        else {
                            // This is when job was just loaded
                            service.job.jobContent.sendRulesRight = [];
                            for (var i = 0; i < service.job.jobContent.sendRules.length; i++) {
                                var rule = service.job.jobContent.sendRules[i];
                                service.job.jobContent.sendRulesRight[rule.mediaDestinatorType] = true;
                            }
                            if (service.job.jobContent.sendRulesLeft === undefined) {
                                service.job.jobContent.sendRulesLeft = angular.copy(service.defaultSendRulesLeft);
                            }
                        }
                    }
                },
                updateTargetStats: function () {
                    var deferred = $q.defer();
                    $rootScope.$on('retry-target-stats', function () {
                        console.log("retry target stats");
                        service.job.retryRequest(requestId, jobDataCopy, true, 0);
                    });
                    if (service.job.targets.length === 0) {
                        // Set initial empty stats to update UI
                        service.job.targetStats = {
                            "emailAble": 0,
                            "smsAble": 0,
                            "voiceAble": 0,
                            "noneAble": 0,
                            "totalAble": 0,
                            "totalPeople": 0,
                            "emailMessages": 0,
                            "smsMessages": 0,
                            "voiceMessages": 0
                        };
                        setTimeout(function () {
                            deferred.resolve();
                        });
                    }
                    else {
                        service.job.statsInProgress = true;
                        service.job.httpError = undefined;
                        $log.debug('jobService.updateTargetStats()');
                        if (service.cancelTargetStatsHttpRequest) {
                            console.log('cancel jobService TargetStatsHttpRequest');
                            service.cancelTargetStatsHttpRequest.resolve();
                            //TODO: Find a way to let error handler not report error
                        }
                        else {
                            console.log('not cancel jobService TargetStatsHttpRequest');
                        }
                        service.cancelTargetStatsHttpRequest = $q.defer();
                        var self = this;
                        // TODO: move to method since also used for save function
                        // Create copy that can be manipulated before saving
                        var jobDataCopy = angular.copy(service.job.data);
                        if (jobDataCopy.jobCategory === "recalls") {
                            if (jobDataCopy.jobContent.targets[0] === undefined) {
                                jobDataCopy.jobContent.targets[0].recallInterval = 1;
                            }
                            // In order to account for appointments on the day of recallInterval days ago regardless of the time of day, we look back one day less
                            jobDataCopy.jobContent.targets[0].recallInterval -= 1;
                            // NOTE: We add 1 day after loading job before showing in UI
                        }
                        else if (jobDataCopy.jobCategory === "missed") {
                            jobDataCopy.jobContent.targets[0].scanDaysBack = jobDataCopy.jobContent.sendRulesLeft[3].daysAfterFirst;
                        }
                        var requestId = Math.random().toString(36).slice(2);
                        delete jobDataCopy.jobContent.sendRulesLeft;
                        delete jobDataCopy.jobContent.sendRulesRight;
                        delete jobDataCopy.isValid;
                        delete jobDataCopy.jobMediaTypes;
                        jobDataCopy.batchStart = 0; // to get target groups in batches
                        $enhancedHttp({
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', 'Request-Id': requestId },
                            url: '/servlets/jobs/targetstats/',
                            data: jobDataCopy,
                            timeout: service.cancelTargetStatsHttpRequest.promise,
                            disableErrorDialog: true /*,
                            errorMessage: 'Error getting target stats data from server.'*/
                        })
                            .then(function (response) {
                            service.job.statsInProgress = false;
                            $log.debug('jobService.updateTargetStats() got data from server ' + status);
                            service.job.targetStats = response.targetStats;
                            if (service.job.targetStats.totalPeople === 0) {
                                service.job.targetStats.percentage = 0;
                            }
                            else {
                                service.job.targetStats.percentage = service.job.targetStats.totalAble / service.job.targetStats.totalPeople * 100;
                            }
                            deferred.resolve(response);
                        }, function (response) {
                            if (response !== undefined && response !== null) {
                                console.log(response);
                                service.job.httpError = 'Failed estimating target group!'; // + JSON.stringify(response);
                                if (response.xhrStatus !== undefined && response.xhrStatus === 'abort') {
                                    $log.error('Request cancelled');
                                    service.job.httpError = 'Aborted';
                                }
                                else {
                                    if (response.error.reason === 'Request cancelled by the server due to newer request getting priority (skipped waitForDone)') {
                                        service.job.httpError = undefined;
                                    }
                                    else {
                                        // Only when no other request has since been started
                                        service.job.statsInProgress = false;
                                    }
                                }
                            }
                            else {
                                service.job.statsInProgress = false;
                                $log.error('Error getting target stats data from server:', response);
                            }
                            deferred.reject(response);
                        });
                        $log.debug("request sent");
                        //} else {
                        //    $log.debug("skipping - in progress");
                        //}
                    }
                    return deferred.promise;
                },
                removeTarget: function (target) {
                    for (var i = 0; i < service.job.targets.length; ++i) {
                        if (service.job.targets[i] === target) {
                            service.job.targets.splice(i, 1);
                        }
                    }
                    service.job.updateTargets();
                },
                retryRequest: function (requestId, jobData, retryStarted, retry) {
                    var deferred = $q.defer();
                    var jobDataCopy = jobData;
                    var requestId = requestId;
                    var retries = retry;
                    return $enhancedHttp({
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Request-Id': requestId },
                        url: '/servlets/jobs/retrytargetstats/',
                        data: jobDataCopy,
                        disableErrorDialog: true /*,
                        errorMessage: 'Error getting target stats data from server.'*/
                    })
                        .then(function (response) {
                        if (response.shouldWaitAndRetry) {
                            if (retryStarted) {
                                retries++;
                                retryStarted = false;
                                if (retries === 1) {
                                    service.job.retryInterval = $interval(function () {
                                        service.job.retryRequest(requestId, jobDataCopy, retryStarted, retries);
                                    }, 20000);
                                }
                                if (retries === service.job.maxTries) {
                                    $interval.cancel(service.job.retryInterval);
                                }
                            }
                        }
                        else {
                            $interval.cancel(service.job.retryInterval);
                            if (response.targetStats !== undefined) {
                                service.job.statsInProgress = false;
                                $log.debug('jobService.updateTargetStats() got data from server ' + status);
                                service.job.targetStats = response.targetStats;
                                if (service.job.targetStats.totalPeople === 0) {
                                    service.job.targetStats.percentage = 0;
                                }
                                else {
                                    service.job.targetStats.percentage = service.job.targetStats.totalAble / service.job.targetStats.totalPeople * 100;
                                }
                                service.job.httpError = undefined;
                                deferred.resolve(response);
                            }
                            else {
                                service.job.httpError = 'Failed estimating target group!'; // + JSON.stringify(response);
                            }
                        }
                    });
                },
                updateTargets: function () {
                    // removing the target count requirement as the user will be warned when clicking Send
                    // if (service.job.targets.length < 1){
                    //    service.job.isValid = false;
                    // }
                    service.job.setEdited(true);
                    var changed = true;
                    service.job.calculateMediaType(changed); // TODO: Check if we need to do this any longer
                    // service.job.updateTargetStats();
                },
                // Call this when any filter has changed to update the stats
                filterChanged: function () {
                    service.job.setEdited(true);
                    var changed = true;
                    service.job.calculateMediaType(changed); // TODO: Check if we need to do this any longer
                    service.job.targetStats = {
                        "emailAble": 0,
                        "smsAble": 0,
                        "voiceAble": 0,
                        "noneAble": 0,
                        "totalAble": 0,
                        "totalPeople": 0,
                        "emailMessages": 0,
                        "smsMessages": 0,
                        "voiceMessages": 0
                    };
                    service.job.targetStats.totalPeople = 0;
                    //service.job.updateTargetStats(); // getting results from backend will trigger update of UI (controller watching targetStats)
                },
                // Called to initialize the UI when loading a job
                setGender: function (gender) {
                    if (gender !== undefined && (gender === 'm' || gender === 'fm' || gender === 'mf')) {
                        service.job.jobTargetMale = true;
                    }
                    else {
                        service.job.jobTargetMale = false;
                    }
                    if (gender !== undefined && (gender === 'f' || gender === 'fm' || gender === 'mf')) {
                        service.job.jobTargetFemale = true;
                    }
                    else {
                        service.job.jobTargetFemale = false;
                    }
                },
                setPetGender: function (gender) {
                    if (gender !== undefined && (gender === 'm' || gender === 'fm' || gender === 'mf')) {
                        service.job.jobTargetPetMale = true;
                    }
                    else {
                        service.job.jobTargetPetMale = false;
                    }
                    if (gender !== undefined && (gender === 'f' || gender === 'fm' || gender === 'mf')) {
                        service.job.jobTargetPetFemale = true;
                    }
                    else {
                        service.job.jobTargetPetFemale = false;
                    }
                },
                setAppointmentSince: function (appointmentSince) {
                    if (appointmentSince === undefined) {
                        service.job.isAppointmentSince = false;
                        service.job.jobTargetAppointmentSince = undefined;
                    }
                    else {
                        service.job.isAppointmentSince = true;
                        service.job.jobTargetAppointmentSince = appointmentSince;
                    }
                },
                changeSpecies: function () {
                    service.breed = [];
                    if (service.selectedSpecies !== null) {
                        Object.entries(service.speciesAndBreed).forEach(dt => {
                            if (dt[0] === service.selectedSpecies) {
                                var breedList = dt[1];
                                if (breedList.length > 0) {
                                    breedList.forEach(breed => {
                                        service.breed.push({ label: breed, value: breed });
                                    });
                                }
                            }
                        });
                    }
                    var target = service.job.data.jobContent.targets[0];
                    target.petSpecies = service.selectedSpecies !== null ? service.selectedSpecies : undefined;
                    service.job.filterChanged();
                },
                changedBreed: function () {
                    var target = service.job.data.jobContent.targets[0];
                    target.petBreed = service.selectedBreed !== null ? service.selectedBreed : undefined;
                    service.job.filterChanged();
                },
                getSpecies: function () {
                    var deferred = $q.defer();
                    $enhancedHttp({
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' },
                        url: '/servlets/pets/species',
                        disableErrorDialog: true,
                        errorMessage: 'Error getting target stats data from server.'
                    })
                        .then(function (data) {
                        service.speciesAndBreed = data.species;
                        service.species = [];
                        Object.entries(data.species).forEach(dt => {
                            service.species.push({ label: dt[0], value: dt[0] });
                        });
                        deferred.resolve(data);
                    }, function (data, status) {
                        service.templates.loaded = true;
                        service.templates.inProgress = false;
                        $log.error('Error getting templates data from server');
                        deferred.reject(status);
                    });
                },
                // Called by the UI when changing one of the checkboxes for male/female
                changedGenderFilter: function () {
                    var target = service.job.data.jobContent.targets[0];
                    target.gender = "";
                    target.petGender = undefined;
                    service.job.jobTargetPetMale = false;
                    service.job.jobTargetPetFemale = false;
                    // Replace current gender setting with what the UI is changed to
                    if (target.gender !== undefined) {
                        // Merge male and female settings from the UI to one string
                        if (service.job.jobTargetMale)
                            target.gender += 'm';
                        if (service.job.jobTargetFemale)
                            target.gender += 'f';
                    }
                    service.job.filterChanged();
                },
                changeAppointmentSince: function () {
                    var isAppointmentSince = service.job.isAppointmentSince;
                    if (!isAppointmentSince) {
                        service.job.jobTargetAppointmentSince = undefined;
                    }
                    service.job.changedAppointmentSinceFilter();
                },
                // Called by the UI when changing appointmentSince
                changedAppointmentSinceFilter: function () {
                    var target = service.job.data.jobContent.targets[0];
                    target.appointmentSince = service.job.jobTargetAppointmentSince;
                    service.job.filterChanged();
                },
                changedPetGenderFilter: function () {
                    var target = service.job.data.jobContent.targets[0];
                    target.gender = undefined;
                    target.petGender = "";
                    service.job.jobTargetMale = false;
                    service.job.jobTargetFemale = false;
                    if (service.job.jobTargetPetMale)
                        target.petGender += 'm';
                    if (service.job.jobTargetPetFemale)
                        target.petGender += 'f';
                    service.job.filterChanged();
                },
                // Called to initialize the UI when loading a job
                setAgeFilter: function (age) {
                    service.job.jobTargetAge = age;
                },
                // Called to initialize the UI when loading a job
                setPetAgeFilter: function (age) {
                    service.job.jobTargetPetAge = age;
                },
                // Called by the UI when changing editing the age filter
                changedAgeFilter: function () {
                    service.job.jobTargetPetAge = undefined;
                    // TODO: check syntax (trim spaces, only allow digits, minus and comma, split into intervals/above/below/singles)
                    service.job.data.jobContent.targets[0].age = service.job.jobTargetAge;
                    service.job.filterChanged();
                },
                changedPetAgeFilter: function () {
                    service.job.jobTargetAge = undefined;
                    // TODO: check syntax (trim spaces, only allow digits, minus and comma, split into intervals/above/below/singles)
                    service.job.data.jobContent.targets[0].petAge = service.job.jobTargetPetAge;
                    service.job.filterChanged();
                },
                // Called by the UI when changing the selection of location
                changedLocationFilter: function () {
                    var target = service.job.data.jobContent.targets[0];
                    var location = angular.copy(service.selectedLocation);
                    if (location !== undefined && location !== null && location !== 'Any location') { // TODO: Find better way to identify
                        target.location = location;
                    }
                    else {
                        if (target.location !== undefined) {
                            delete target.location;
                        }
                    }
                    service.job.filterChanged();
                },
                // Called by the UI when changing the selection of provider
                changedProviderFilter: function () {
                    var target = service.job.data.jobContent.targets[0];
                    var providerId = angular.copy(service.selectedProviderId);
                    if (providerId !== undefined && providerId !== null) {
                        target.providerId = providerId;
                    }
                    else {
                        if (target.providerId !== undefined) {
                            delete target.providerId;
                        }
                    }
                    service.job.filterChanged();
                },
                // Called by the UI when changing the selection of reason
                changedReasonFilter: function () {
                    var target = service.job.data.jobContent.targets[0];
                    var reasonId = angular.copy(service.selectedReasonId);
                    if (reasonId !== undefined && reasonId !== null) {
                        target.reasonId = reasonId;
                    }
                    else {
                        if (target.reasonId !== undefined) {
                            delete target.reasonId;
                        }
                    }
                    service.job.filterChanged();
                },
                changedSinceDaysFilter: function () {
                    var target = service.job.data.jobContent.targets[0];
                    // Ensure UI works on comparison with numbers
                    service.job.appointmentsSinceDaysAgo = parseInt(service.job.appointmentsSinceDaysAgo);
                    target.appointmentsSinceDaysAgo = service.job.appointmentsSinceDaysAgo;
                    //
                    // if (service.job.minAppointments > 0) {
                    //     service.job.targetDateFrom = target.from || moment().format("YYYY-MM-DD"); // today
                    //     service.job.targetDateTo = target.to || moment().format("YYYY-MM-DD"); // today
                    //     if (target.from === undefined) {
                    //         target.from = service.job.targetDateFrom;
                    //     }
                    //     if (target.to === undefined) {
                    //         target.to = service.job.targetDateTo;
                    //     }
                    // } else {
                    //     target.from = undefined;
                    //     target.to = undefined;
                    // }
                    service.job.filterChanged();
                },
                // Called by the UI when changing the selection of appointment state
                changedAppointmentStateFilter: function () {
                    var firstTarget = service.job.data.jobContent.targets[0];
                    if (service.selectedRemoteAppointmentState === null) {
                        delete firstTarget.remoteAppointmentState;
                    }
                    else {
                        firstTarget.remoteAppointmentState = service.selectedRemoteAppointmentState;
                    }
                    service.job.filterChanged();
                },
                // Called by the UI when changing appointment period filter
                changedPeriodFilter: function () {
                    var target = service.job.data.jobContent.targets[0];
                    // NOTE: If date not specified it will be set to today
                    target.from = moment(service.job.targetDateFrom).format("YYYY-MM-DD");
                    target.to = moment(service.job.targetDateTo).format("YYYY-MM-DD");
                    service.job.filterChanged();
                },
                // Called by the UI when changing appointment period filter
                changedAppointmentNumberFilter: function () {
                    var target = service.job.data.jobContent.targets[0];
                    // Ensure UI works on comparison with numbers
                    service.job.minAppointments = parseInt(service.job.minAppointments);
                    target.minAppointments = service.job.minAppointments;
                    if (service.job.minAppointments !== 0) {
                        service.job.targetDateFrom = new Date(target.from || moment().add(-1, 'years').format("YYYY-MM-DD")); // -1 year
                        service.job.targetDateTo = new Date(target.to || moment().format("YYYY-MM-DD")); // today
                        if (target.from === undefined) {
                            target.from = moment(service.job.targetDateFrom).format("YYYY-MM-DD");
                        }
                        if (target.to === undefined) {
                            target.to = moment(service.job.targetDateTo).format("YYYY-MM-DD");
                        }
                    }
                    else {
                        target.from = undefined;
                        target.to = undefined;
                        service.job.targetDateFrom = undefined;
                        service.job.targetDateTo = undefined;
                    }
                    service.job.filterChanged();
                },
                // This is called by setCurrentJob to update the drop-down in the UI
                setHourOfDay: function (hour) {
                    if (typeof service.hoursOfDay === 'undefined') {
                        return;
                    }
                    for (var i = 0; i < service.hoursOfDay.length; ++i) {
                        var hourOfDay = service.hoursOfDay[i];
                        if (hourOfDay.hour === hour) {
                            service.job.hourOfDay = hourOfDay;
                        }
                    }
                },
                // This is called by UI when selecting an option in the drop-down
                setTriggerHour: function () {
                    service.job.jobContent.triggerSetting.triggerHour = service.job.hourOfDay.hour;
                    service.job.setEdited(true);
                },
                setTriggerOffsetMinutes: function () {
                    service.job.jobContent.triggerSetting.triggerOffsetMinutes = service.job.triggerOffsetMinutes;
                    // service.job.setEdited(true);
                },
                // This is called by setCurrentJob to update the drop-down in the UI
                setDayOfMonth: function (day) {
                    if (typeof service.daysOfMonth === 'undefined') {
                        return;
                    }
                    if (day === undefined || day === null) {
                        service.job.dayOfMonth = service.daysOfMonth[0];
                        return;
                    }
                    for (var i = 0; i < service.daysOfMonth.length; ++i) {
                        var dayOfMonth = service.daysOfMonth[i];
                        if (dayOfMonth.day === day) {
                            service.job.dayOfMonth = dayOfMonth;
                            return;
                        }
                    }
                },
                // This is called by UI when selecting an option in the drop-down
                setTriggerDay: function () {
                    var day = service.job.dayOfMonth;
                    service.job.jobContent.triggerSetting.triggerDay = day.day;
                    service.job.setEdited(true);
                }
                /*
                trustSrc: function(src) {
                    debugger;
                            var url = 'http://api.voicerss.org/?key=363f493758f1485484da02405429a25d&hl=en-us&c=wav&f=8khz_8bit_mono&r=-4&src=';
                            url += src;
                            return $sce.trustAsResourceUrl(url);
                }
                */
            },
            // ----------------------------------------------------------------------
            // model
            templates: {
                loaded: false,
                last: 0,
                list: [],
                inProgress: false,
                getTemplates: function () {
                    // Reset list and offset
                    service.templates.list = [];
                    service.templates.last = 0;
                    return service.templates.getMoreTemplates(this);
                },
                getMoreTemplates: function (model) {
                    var deferred = $q.defer();
                    if (!service.templates.inProgress) {
                        service.templates.inProgress = true;
                        $log.debug('jobService.getMoreTemplates(offset=' + model.last + ')');
                        $enhancedHttp({
                            method: 'GET',
                            headers: { 'Content-Type': 'application/json' },
                            url: 'servlets/templates/?offset=' + model.last,
                            disableErrorDialog: false,
                            errorMessage: 'Error getting templates data from server.'
                        })
                            .then(function (data, status) {
                            service.templates.loaded = true;
                            for (var i = 0; i < data.templates.length; i++) {
                                // Only add new elements if not already in the list
                                var alreadyInList = false;
                                for (var j = 0; j < model.list.length; j++) {
                                    if (model.list[j] === data.templates[i]) {
                                        alreadyInList = false;
                                        break;
                                    }
                                }
                                if (!alreadyInList) {
                                    model.list.push(data.templates[i]);
                                }
                                model.last++;
                            }
                            model.inProgress = false;
                            deferred.resolve(model.list);
                        }, function (data, status) {
                            service.templates.loaded = true;
                            service.templates.inProgress = false;
                            $log.error('Error getting templates data from server');
                            deferred.reject(status);
                        });
                    }
                    else {
                        $log.debug("skipping - in progress");
                    }
                    return deferred.promise;
                }
            },
            // NOTE: Keep this model clean to ONLY contain data that comes from the database and/or should go into the database (and no functions)
            template: {
                templateId: -1,
                templateUrl: null,
                voiceTemplateUrl: null,
                //smsMessage: 'empty',
                defaultContent: null,
                surveyUrl: '',
                surveyResultUrl: '',
            },
            clearModel: function () {
                service.inProgress = false;
                service.selectedCategory = null;
                service.categories = [];
                service.job.inProgress = false;
                service.jobFormDirty = false;
                service.jobs.last = 0;
                service.jobs.list = [];
                service.job.clonable = false;
                service.templates.last = 0;
                service.templates.list = [];
                service.templates.inProgress = false;
                service.job.data = null;
                service.job.isAutomatedCategory = false;
                service.job.jobChanged = false;
                service.job.editable = true;
                service.job.jobConfirm = false;
                service.job.edited = false;
                service.job.clonable = false;
                service.job.targets = [];
                service.job.targetStats = {};
                service.selectedSpecies = null;
                service.selectedBreed = null;
                service.breed = [];
            }
        };
        $rootScope.$on('event:auth-logout', function () {
            $log.debug('jobService.clear: killing service data');
            service.clearModel();
        });
        return service;
        /*
         * store each mediaType+template(+fragment) in a table like strategytriggers? no need - only to run stats and quick search for template usage
         *
         *
         */
    }]);
//# sourceMappingURL=job.services.js.map